export const environment = {
  production: false,
  baseServerUrl: "https://homologacaosedintegracoes.educacao.sp.gov.br/conviva/",
  baseFrontUrl: "https://homologacaoconviva.educacao.sp.gov.br/",
  baseSedUrl: "https://homologacaosedintegracoes.educacao.sp.gov.br/credenciais/",
  hubUrl: "https://see-h-apiconviva.azurewebsites.net/",
  diarioUrl: "https://homologacaosedintegracoes.educacao.sp.gov.br/diarioclasse/",
  diarioKey: "bf55629f41d144a1b9297d7dcbc16c2d",
  clientId: "seduc.conviva-portal",
  Apim: "56be8c628f0b4474b691ab314b90a800",
  ApimConviva: "722fa3cef8c943ba945f005169b04322",
  IdpSP: "https://rhsso.idp-hml.sp.gov.br/auth/realms/idpsp",
  IdpSpToken: "https://rhsso.idp-hml.sp.gov.br/auth/realms/idpsp/protocol/openid-connect/token",

  //login cyberark
  IdpMasp: "https://abc4967.id.cyberark.cloud",
  clientIdMasp: "92fc7fb7-3dea-4753-8195-743016b56da5",
  IdpMaspLogin: "https://abc4967.id.cyberark.cloud/OAuth2/Authorize/conviva_hml/",
  IdpMaspLogout: "https://hml-prodesp.id.cyberark.cloud/OAuth2/EndSessionV2/conviva_hml",
  IdpMaspToken: "https://abc4967.id.cyberark.cloud/OAuth2/Token",
  appKeyMasp: "conviva_hml",

  version: "1.1.0",
  // googleAPIKey:"AIzaSyBW3-1Uqc00l6-rwd-KZkdIZWmS5MnGMsk"
  appInsights: "InstrumentationKey=904907b1-127c-4199-98b6-66b1c4b416ca;IngestionEndpoint=https://eastus2-3.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus2.livediagnostics.monitor.azure.com/;ApplicationId=bd80c307-b3a3-47e9-aeee-90898d518509",
  googleAnalyticsToken: "",
  
  // Controle de período eleitoral
  periodoEleitoral: true,

  appVersionCheck: {
    enabled: true,
    pollIntervalMs: 300_000,
    reloadCountdownSeconds: 30
  }
};
